import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { booksResultsPath, cleanFilterParams, filtersFromSearch, QUICK_LOOK_PARAM } from "./booksQueryParams";

const LEGACY_PAGINATION_KEYS = ["page", "first_page", "rows"];
const FILTER_ACTIONS = {
	changeCategoryIs: "category_is", changeGenreIs: "genre_is", changeTagIs: "tag_is",
	changePublisherIs: "publisher_is", changePricingModelIs: "pricing_model_is",
	changeSearchTerm: "search_term", changeCountryIs: "country_is",
	changePublicationDateFrom: "publication_date_from", changePublicationDateTo: "publication_date_to",
	changePriceMin: "price_min", changePriceMax: "price_max", changeFormat: "format",
	changeAvailability: "availability", changePageCountMin: "page_count_min",
	changePageCountMax: "page_count_max", changeLanguage: "language",
};

const useBooksFilters = () => {
	const { search, pathname } = useLocation();
	const history = useHistory();
	const filters = useMemo(() => filtersFromSearch(search), [search]);
	const changeFilters = useCallback((patch, { replace = false } = {}) => {
		const params = new URLSearchParams(search);
		Object.entries(patch).forEach(([key, value]) => {
			if (value == null || value === "") params.delete(key);
			else params.set(key, value);
		});
		LEGACY_PAGINATION_KEYS.forEach((key) => params.delete(key));
		params.delete(QUICK_LOOK_PARAM);
		const query = params.toString();
		if (query === search.replace(/^\?/, "")) return;
		history[replace ? "replace" : "push"](query ? `${pathname}?${query}` : pathname);
	}, [history, pathname, search]);
	const actions = useMemo(() => ({
		...Object.fromEntries(Object.entries(FILTER_ACTIONS).map(([action, key]) => [action, (value, options) => changeFilters({ [key]: value }, options)])),
		changeFilters,
		changeAllFiltersAtOnce: (data) => history.push(booksResultsPath(cleanFilterParams(data))),
	}), [changeFilters, history]);
	return useMemo(() => ({ ...filters, ...actions }), [filters, actions]);
};
export default useBooksFilters;
